
















// eslint-disable-next-line import/no-extraneous-dependencies
import {
    Vue,
    Prop,
    Component,
} from 'vue-property-decorator';

import {
    // eslint-disable-next-line camelcase
    E_CaseTimeStatus,
    IUserCaseItem,
} from '../../service/caseTime.types';
import { i18nOption } from '../../i18n/i18n';

@Component({
    name: 'CaseTimeButton',
    i18n: i18nOption,
})
class CaseTimeButtonImpl extends Vue {
    @Prop({
        type: Object,
        required: false,
        default() {
            return {};
        },
    })
    userCaseItem: IUserCaseItem

    get IsRecording() {
        return this.Status === E_CaseTimeStatus.WORKING;
    }

    get Status() {
        return this.userCaseItem.status || E_CaseTimeStatus.DONE;
    }

    onClick() {
        this.$emit('click');
    }
}

export default CaseTimeButtonImpl;
